module.exports = __webpack_public_path__ + "static/media/main-image-tablet.59525c93.png";